import { render } from "./AdultsSectionThree.vue?vue&type=template&id=39a4f564&scoped=true"
const script = {}

import "./AdultsSectionThree.vue?vue&type=style&index=0&id=39a4f564&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a4f564"]])

export default __exports__